const SECTORS = [
    {
        t: "Inmobiliario",
        d: "Agentes top performers y agencias boutique que pierden operaciones de seis cifras porque el primer contacto llegó cuatro horas tarde.",
    },
    {
        t: "Servicios profesionales regulados",
        d: "Abogados, asesores fiscales, asesores financieros, family offices. Despachos donde el socio principal es el único que puede cerrar — y por eso el embudo nuevo se atasca en su agenda.",
    },
    {
        t: "Salud y bienestar prime",
        d: "Clínicas dentales, estéticas, capilares, fertilidad, fisio, veterinarias. Operaciones donde la primera respuesta determina si el paciente acaba en tu consulta o en la del vecino.",
    },
    {
        t: "Financiero e intermediación",
        d: "Brokers de seguros, hipotecas y asesores financieros independientes. Modelos basados en cualificación rigurosa donde la velocidad y la trazabilidad son la operación entera.",
    },
    {
        t: "Hospitality, eventos y restauración prime",
        d: "Restaurantes con propuesta cuidada, hoteles boutique, espacios para eventos y organizadores. Negocios donde la primera respuesta — al teléfono, al WhatsApp, al email — determina si la reserva acaba contigo o con el de al lado.",
    },
];

export default function Sectors() {
    return (
        <section
            id="sectores"
            data-testid="sectors-section"
            className="bg-white py-28 md:py-40"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[920px]">
                    <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05]">
                        Cinco sectores donde llevamos ventaja.
                    </h2>
                    <p className="mt-5 font-serif-display italic text-lg md:text-2xl text-[#666666]">
                        No trabajamos con todo el mundo. Nos especializamos donde tenemos lectura profunda del negocio.
                    </p>
                </div>

                <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {SECTORS.map((s, i) => (
                        <article
                            key={s.t}
                            data-testid={`sector-${i}`}
                            className="bg-white border border-[#E5E0D5] p-8 md:p-10 hover:border-[#8B6914] hover:-translate-y-1 transition-all duration-300"
                        >
                            <p className="text-xs tracking-[0.2em] uppercase text-[#8B6914]">
                                {String(i + 1).padStart(2, "0")}
                            </p>
                            <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A1A1A] mt-4 leading-tight">
                                {s.t}
                            </h3>
                            <span className="block h-px w-12 bg-[#8B6914] mt-6" />
                            <p className="mt-6 text-[15px] md:text-base text-[#666666] leading-[1.7]">
                                {s.d}
                            </p>
                        </article>
                    ))}
                </div>

                <p className="mt-16 font-serif-display italic text-lg md:text-xl text-[#1A1A1A] max-w-[760px]">
                    Si tu sector no está aquí pero tu modelo sí, hablemos.
                </p>
            </div>
        </section>
    );
}
